export const brandSettings = {
  hasCurbside: true,
  hasShipping: true,
  hasDelivery: true,
  hasProductRatings: false,
  hasProductSearch: false,
}  as const;
